<template>
  <div>
    <b-row>
      <b-col
        lg="6"
        md="6"
        sm="12"
      >
        <b-link
          style="font-size: 26px; color: #fff;"
          :to="{ path: `/bridge-sub?DeptID=${deptid}` }"
        >
          <feather-icon
            style="margin-bottom: 5px;"
            size="34"
            icon="ArrowLeftIcon"
          /><span style="color: #00FF80;">สะพาน: </span>{{ waydetail }}
        </b-link>
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col
        lg="8"
        md="8"
      >
        <!-- แผนที่ -->
        <b-card style="font-size:18px; background-color:rgba(0, 0, 0, 0); width: 100%; color:#ffffff; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
          <div>
            <!-- Map2🚀 -->
            <b-card
              style="font-size:18px; background-color:rgba(0, 0, 0, 0.0); color:#ffffff; border: 0px solid #ffffff; border-radius: 20px;"
              no-body
            >
              <b-card-header>
                <h4
                  class="mb-0"
                  style="text-decoration: underline;"
                >
                  <!-- {{ name }}55555555 -->
                </h4>
                <div>
                  <b-dropdown
                    id="dropdown-1"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    text="ดูข้อมูลย้อนหลัง"
                    variant="primary"
                  >
                    <b-dropdown-item @click="historyAllShip(wid)">
                      เรือทั้งหมด
                    </b-dropdown-item>
                    <b-dropdown-item @click="historyHighShip(wid)">
                      เรือสูงเกินกำหนด
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-b-modal="'modalWater'"
                      @click="$refs.childref.sendInfo(data.item.id)"
                    >
                      ระดับน้ำ
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </b-card-header>
              <l-map
                ref="map"
                style="font-size:18px; background-color:rgba(0, 0, 0, 0); color:#ffffff; height: 510px;"
                :crs="crs"
                :min-zoom="minZoom"
                :options="{scrollWheelZoom:false, zoomControl: false, attributionControl:false}"
              >
                <l-image-overlay
                  :url="require('@/assets/images/icons/bridge/sensor/Smart_Bridge.png')"
                  :bounds="bounds"
                />
                <l-marker
                  :lat-lng="[0, 330]"
                  :icon="iconSiren"
                />
                <l-marker
                  :lat-lng="[-100, 360]"
                  :icon="iconSpeaker"
                />
                <!-- <l-image-overlay
                    v-if="status === 1"
                    :url="require('@/assets/images/icons/bridge/sensor/sensor-warning2.gif')"
                    :bounds="bounds"
                  />
                  <l-image-overlay
                    v-if="status === 2"
                    :url="require('@/assets/images/icons/bridge/sensor/sensor-danger2.gif')"
                    :bounds="bounds"
                  />
                  <l-image-overlay
                    v-if="status === 0"
                    :url="require('@/assets/images/icons/bridge/sensor/Smart_Bridge.png')"
                    :bounds="bounds"
                  />
                  <l-marker
                    v-if="status === 2"
                    :lat-lng="[0, 330]"
                    :icon="iconSiren"
                  />
                  <l-marker
                    v-if="status === 2"
                    :lat-lng="[-100, 360]"
                    :icon="iconSpeaker"
                  /> -->
              </l-map>
            </b-card>
          </div>
        </b-card>

      </b-col>
      <b-col
        lg="4"
        md="4"
      >
        <b-row>
          <!-- กล้อง 1 -->
          <b-col v-if="namecam0">
            <b-col
              class="mb-1"
              align-self="baseline"
              lg="12"
              md="12"
            >
              <svg
                width="105%"
                height="100%"
                viewBox="0 0 1046 691"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style="margin-left: -15px;"
              >
                <path
                  d="M964.03 688.647H964.031H1045.5V644.686V600.225V351.058V101.89V44.9474L1011.78 0.5H0.5V44.4611V88.9222V596.52V646.01L34.2183 690.5L964.03 688.647Z"
                  stroke="#00B058"
                />
                <path
                  d="M66 689H29.9165L2 649.571V605"
                  stroke="#00B058"
                  stroke-width="4"
                />
                <path
                  d="M974 2H1013.47L1044 38.6122V80"
                  stroke="#00B058"
                  stroke-width="4"
                />
                <foreignObject
                  width="100%"
                  height="100%"
                  x="25"
                  y="7"
                >
                  <div>
                    <b-img
                      height="55"
                      src="@/assets/images/icons/cctv.svg"
                    />
                  </div>
                </foreignObject>
                <foreignObject
                  width="100%"
                  height="100%"
                  x="100"
                  y="10"
                >
                  <div>
                    <span class="text3">กล้องวงจรปิด(ขาขึ้น)</span>
                  </div>
                </foreignObject>
                <foreignObject
                  x="25"
                  y="70"
                  width="100%"
                  height="80%"
                >
                  <div>
                    <video
                      :id="'video' + 0"
                      style="width:95%; height:auto; flex-direction: row;"
                      muted
                      autoplay
                      playsinline
                    />
                  </div>
                </foreignObject>

                <foreignObject
                  x="20"
                  y="627"
                  width="100%"
                  height="90%"
                >
                  <div>
                    <h1 class="text2 mt-1"> {{ namecam0 }}</h1>
                  </div>
                </foreignObject>
                <foreignObject
                  x="30"
                  y="632"
                  width="100%"
                  height="90%"
                >
                  <svg
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style="overflow: auto;"
                  >
                    <rect
                      width="48"
                      height="48"
                      rx="4"
                      fill="url(#paint0_linear_431_10636)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_431_10636"
                        x1="24"
                        y1="0"
                        x2="24"
                        y2="48"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#99FBCA" />
                        <stop
                          offset="0.404167"
                          stop-color="#00B058"
                        />
                      </linearGradient>
                    </defs>
                    <foreignObject
                      width="100%"
                      height="100%"
                      y="9"
                      style="text-align:center"
                    >
                      <h1> 1 </h1>
                    </foreignObject>
                  </svg>
                </foreignObject>
              </svg>
            </b-col>
          </b-col>

          <b-col
            v-else
            class="mb-1"
            align-self="baseline"
            lg="12"
            md="12"
          >
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 1046 691"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M964.03 688.647H964.031H1045.5V644.686V600.225V351.058V101.89V44.9474L1011.78 0.5H0.5V44.4611V88.9222V596.52V646.01L34.2183 690.5L964.03 688.647Z"
                stroke="#00B058"
              />
              <path
                d="M66 689H29.9165L2 649.571V605"
                stroke="#00B058"
                stroke-width="4"
              />
              <path
                d="M974 2H1013.47L1044 38.6122V80"
                stroke="#00B058"
                stroke-width="4"
              />
              />
              <foreignObject
                width="100%"
                height="100%"
                x="25"
                y="7"
              >
                <div>
                  <b-img
                    height="55"
                    src="@/assets/images/icons/cctv.svg"
                  />
                </div>
              </foreignObject>
              <foreignObject
                width="100%"
                height="100%"
                x="100"
                y="10"
              >
                <div>
                  <span class="text3">กล้องวงจรปิด(ขาขึ้น)</span>
                </div>
              </foreignObject>
              <foreignObject
                x="25"
                y="70"
                width="100%"
                height="90%"
              >
                <div
                  style="margin-right: 70px;"
                >
                  <center>
                    <img
                      height="620px"
                      src="@/assets/images/icons/markeranalytic120/Nocctv.svg"
                    >
                  </center>
                </div>
              </foreignObject>
            </svg>
          </b-col>

          <!-- กล้อง 2  -->
          <b-col
            v-if="namecam1"
            cols="12"
          >
            <b-col
              class="mb-1"
              align-self="baseline"
              lg="12"
              md="12"
            >
              <svg
                width="105%"
                height="100%"
                viewBox="0 0 1046 691"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style="margin-left: -15px;"
              >
                <path
                  d="M964.03 688.647H964.031H1045.5V644.686V600.225V351.058V101.89V44.9474L1011.78 0.5H0.5V44.4611V88.9222V596.52V646.01L34.2183 690.5L964.03 688.647Z"
                  stroke="#00B058"
                />
                <path
                  d="M66 689H29.9165L2 649.571V605"
                  stroke="#00B058"
                  stroke-width="4"
                />
                <path
                  d="M974 2H1013.47L1044 38.6122V80"
                  stroke="#00B058"
                  stroke-width="4"
                />
                <foreignObject
                  width="100%"
                  height="100%"
                  x="25"
                  y="7"
                >
                  <div>
                    <b-img
                      height="55"
                      src="@/assets/images/icons/cctv.svg"
                    />
                  </div>
                </foreignObject>
                <foreignObject
                  width="100%"
                  height="100%"
                  x="100"
                  y="10"
                >
                  <div>
                    <span class="text3">กล้องวงจรปิด(ขาล่อง)</span>
                  </div>
                </foreignObject>
                <foreignObject
                  x="25"
                  y="70"
                  width="100%"
                  height="90%"
                >
                  <div>
                    <video
                      :id="'video' + 1"
                      style="width:95%; height:auto; flex-direction: row;"
                      muted
                      autoplay
                      playsinline
                    />
                  </div>
                </foreignObject>

                <foreignObject
                  x="20"
                  y="627"
                  width="100%"
                  height="90%"
                >
                  <div>
                    <h1 class="text2 mt-1"> {{ namecam1 }}</h1>
                  </div>
                </foreignObject>
                <foreignObject
                  x="30"
                  y="632"
                  width="100%"
                  height="90%"
                >
                  <svg
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style="overflow: auto;"
                  >
                    <rect
                      width="48"
                      height="48"
                      rx="4"
                      fill="url(#paint0_linear_431_10636)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_431_10636"
                        x1="24"
                        y1="0"
                        x2="24"
                        y2="48"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#99FBCA" />
                        <stop
                          offset="0.404167"
                          stop-color="#00B058"
                        />
                      </linearGradient>
                    </defs>
                    <foreignObject
                      width="100%"
                      height="100%"
                      y="9"
                      style="text-align:center"
                    >
                      <h1> 2 </h1>
                    </foreignObject>
                  </svg>
                </foreignObject>
              </svg>
            </b-col>
          </b-col>

          <b-col
            v-else
            class="mb-1"
            align-self="baseline"
            lg="12"
            md="12"
          >
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 1046 691"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M964.03 688.647H964.031H1045.5V644.686V600.225V351.058V101.89V44.9474L1011.78 0.5H0.5V44.4611V88.9222V596.52V646.01L34.2183 690.5L964.03 688.647Z"
                stroke="#00B058"
              />
              <path
                d="M66 689H29.9165L2 649.571V605"
                stroke="#00B058"
                stroke-width="4"
              />
              <path
                d="M974 2H1013.47L1044 38.6122V80"
                stroke="#00B058"
                stroke-width="4"
              />
              />
              <foreignObject
                width="100%"
                height="100%"
                x="25"
                y="7"
              >
                <div>
                  <b-img
                    height="55"
                    src="@/assets/images/icons/cctv.svg"
                  />
                </div>
              </foreignObject>
              <foreignObject
                width="100%"
                height="100%"
                x="100"
                y="10"
              >
                <div>
                  <span class="text3">กล้องวงจรปิด(ขาล่อง)</span>
                </div>
              </foreignObject>
              <foreignObject
                x="25"
                y="70"
                width="100%"
                height="90%"
              >
                <div
                  style="margin-right: 70px;"
                >
                  <center>
                    <img
                      height="620px"
                      src="@/assets/images/icons/markeranalytic120/Nocctv.svg"
                    >
                  </center>
                </div>
              </foreignObject>
            </svg>
          </b-col>
        </b-row>
      </b-col>
      <!-- <b-img :src="items[0].FilePath" /> -->
    </b-row>
    <modalWater />
  </div>
</template>

<script>
/* eslint-disable global-require */
import Hls from 'hls.js'
import {
  BRow, BCol, BImg, BLink, BCard, BCardHeader, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import {
  LMap, LMarker,
  // LIcon, LPopup,
  LImageOverlay,
} from 'vue2-leaflet'
import axios from '@axios'
import { Icon, CRS, icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
// eslint-disable-next-line import/order
import Ripple from 'vue-ripple-directive'
import modalWater from './modalWater.vue'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
/* eslint-disable global-require */
export default {
  components: {
    BRow,
    BCol,
    LMap,
    LMarker,
    // LIcon,
    // LPopup,
    LImageOverlay,
    BImg,
    BLink,
    BCard,
    BCardHeader,
    BDropdown,
    BDropdownItem,
    modalWater,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 0,
      crs: CRS.Simple,
      bounds: [[-300, -500], [300, 1000]],
      center: [18.839867, 98.973773],
      minZoom: -100,
      waydetail: '',
      markers: [],
      detail: '',
      deptid: '',
      img: '',
      rtsp: [],
      namecam0: '',
      namecam1: '',
      lat: '',
      lng: '',
      type_name: '',
      camid: '',
      camdesc: '',
      detection: '',
      date: '',
      anydesk: '',
      anydesk1: '',
      live: '',
      iconSiren: icon({
        iconUrl: require('@/assets/images/icons/bridge/sensor/siren.gif'),
        iconSize: [40, 40],
      }),
      iconSpeaker: icon({
        iconUrl: require('@/assets/images/icons/bridge/sensor/speaker.gif'),
        iconSize: [60, 60],
      }),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
    clearInterval(this.interval1)
  },
  mounted() {
    this.$refs.map.mapObject.setView([0, 250], -1)
    this.for()
    this.getCamBridge()
    this.getWayBridgeAnalytic()

    this.interval = setInterval(() => {
      this.getEventImgAnalytic()
    }, 300000)
    this.interval1 = setInterval(() => {
      this.for()
      this.getCamBridge()
    }, 300000)
  },
  methods: {
    getWayBridgeAnalytic() {
      axios
        .post('/wayBridgeDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.zoom = response.data[0].mapzoom
          this.deptid = response.data[0].deptid
          this.center = []
          this.center.push(response.data[0].latitude)
          this.center.push(response.data[0].longitude)
          this.waydetail = response.data[0].detail
          this.type_name = response.data[0].type_name
          this.live = response.data[0].desktop_screen
          this.anydesk1 = response.data[0].anydesk
          this.anydesk = `anydesk:${response.data[0].anydesk}`
        })
        .catch(error => {
          console.log(error)
        })
    },
    // กล้องข้าง map 2 ตัว
    getCamBridge() {
      axios
        .post('/getCamBridgeDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.rtsp = response.data
          this.namecam0 = response.data[0].Camera_Desc
          this.namecam1 = response.data[1].Camera_Desc
        })
        .catch(error => {
          console.log(error)
        })
    },
    for() {
      setTimeout(() => this.rtsp.forEach((value, i) => {
        this.stream(value.RTSP_HLS, i)
      }), 500)
    },
    stream(value, i) {
      console.log(value)
      this.hls = new Hls({
        lowLatencyMode: true,
        autoreconnect: true,
      })
      const video = document.querySelector(`#video${i}`)
      const videoSrc = value
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc
      } else if (Hls.isSupported()) {
        this.hls.loadSource(videoSrc)
        this.hls.attachMedia(video)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
      }
    },

    getEventImgAnalytic() {
      axios
        .post('/getEventImgAIDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.camid = response.data[0].CAMID
          this.camdesc = response.data[0].Camera_Desc
          this.detection = response.data[0].Detection_Type
          this.date = response.data[0].DATE_TIME
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style scoped>
.text3 {
font-size: 44px;
color: #ffffff;
}
.text2 {
font-size: 34px;
color: #ffffff;
text-align: center;
}
</style>
